import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getAverageSleep } from '../actions/recoveryAction';


export interface AverageSleepState {
  averageSleep: number | undefined;
  loading: boolean;
  error: string | null;
}

const initialState: AverageSleepState = {
  averageSleep: undefined,
  loading: false,
  error: ''
};

const averageSleepSlice = createSlice({
  name: 'averageSleep',
  initialState: initialState,
  reducers: {
    averageSleep: (state: AverageSleepState, action: PayloadAction<number>) => { 
      state.averageSleep = action.payload;
    }
  },
  extraReducers: (builder) => {
    // load averageRecovery
    builder.addCase(getAverageSleep.pending, (state: AverageSleepState) => {
        state.loading = true
        state.error = null
    }),
    builder.addCase(getAverageSleep.fulfilled, (state: AverageSleepState, { payload }: PayloadAction<number>) => {
        state.loading = false
        state.averageSleep = payload
    }),
    builder.addCase(getAverageSleep.rejected, (state: AverageSleepState, { payload }: PayloadAction<any>) => {
        state.loading = false
        state.error = payload
    })
  }
});

export const { averageSleep } = averageSleepSlice.actions;

export default averageSleepSlice.reducer;